import axios from '../../helpers/axios-setup';

export const publishCertificationById = (id: number) => axios.post(`/certifications/${id}/publish`);
